import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Prescriptions = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="prescriptions icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51 61C56.5228 61 61 56.5228 61 51C61 45.4772 56.5228 41 51 41C45.4772 41 41 45.4772 41 51C41 56.5228 45.4772 61 51 61ZM51 64C58.1797 64 64 58.1797 64 51C64 43.8203 58.1797 38 51 38C43.8203 38 38 43.8203 38 51C38 58.1797 43.8203 64 51 64Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51 23C56.5228 23 61 18.5228 61 13C61 7.47715 56.5228 3 51 3C45.4772 3 41 7.47715 41 13C41 18.5228 45.4772 23 51 23ZM51 26C58.1797 26 64 20.1797 64 13C64 5.8203 58.1797 0 51 0C43.8203 0 38 5.8203 38 13C38 20.1797 43.8203 26 51 26Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <rect
      x="54.182"
      y="45.6968"
      width="3"
      height="12"
      rx="1.5"
      transform="rotate(45 54.182 45.6968)"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <rect
      x="54.182"
      y="7.69678"
      width="3"
      height="12"
      rx="1.5"
      transform="rotate(45 54.182 7.69678)"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M3 34H23V51C23 56.5228 18.5228 61 13 61V61C7.47715 61 3 56.5228 3 51V34Z"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 51V13C23 7.47715 18.5228 3 13 3C7.47715 3 3 7.47715 3 13V51C3 56.5228 7.47715 61 13 61C18.5228 61 23 56.5228 23 51ZM13 0C5.8203 0 0 5.8203 0 13V51C0 58.1797 5.8203 64 13 64C20.1797 64 26 58.1797 26 51V13C26 5.8203 20.1797 0 13 0Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <rect
      y="31"
      width="26"
      height="3"
      className={`color-iconBrand-default ${pathClass}`}
    />
  </svg>
)
